  <!-- Header -->
  <div mat-dialog-title >
    {{'Add_Roles' | translate}}
    <div class="spacer"></div><mat-icon mat-dialog-close>close</mat-icon>
  </div>

  <!-- Content -->
  <mat-dialog-content>
        <div class="input-container">
          <mat-form-field [subscriptSizing]="'dynamic'" appearance="outline"  floatLabel="always" >
            <mat-label>{{'Role_Name' | translate}}</mat-label>
            <input matInput [(ngModel)]="inputValue" placeholder="Role Name">
          </mat-form-field>
          <div matRipple matRippleColor="primary" class="btn-arrow" (click)="input($event)"><mat-icon>arrow_forward</mat-icon></div>
        </div>
        <div>
          <mat-chip-set>
            @for (role of customRoles; track role) {
            <mat-chip (removed)="removeRole(role)">
              {{role.name}}
              <span matChipRemove><mat-icon>cancel</mat-icon></span>
            </mat-chip>
            }
          </mat-chip-set>
        </div>
  </mat-dialog-content>

  <!-- Footer -->
  <mat-dialog-actions align="end">
      <button mat-stroked-button color="primary" (click)="close()">{{'BUTTONS.close' | translate}}</button>
      <button mat-flat-button color="primary" [disabled]="customRoles.length === 0" (click)="saveData()">{{'BUTTONS.save' | translate}}</button>
  </mat-dialog-actions>
